import React, { useEffect, useState, useContext } from 'react';
import { Typography, Link } from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import axios from 'axios';
import API_URL from '../config/config';
import { contactContext } from '../context/contactContext';

export interface MedicalLicense {
  Id: string;
  License_Number: string | null;
  StateProvince: { Name: string; IsoCode: string } | null;
}

interface LicensesSectionProps {
  onLicensesLoaded: (licenses: MedicalLicense[]) => void;
  credentialsUrl: string;
}

const LicensesSection: React.FC<LicensesSectionProps> = ({ onLicensesLoaded, credentialsUrl }) => {
  const [licenses, setLicenses] = useState<MedicalLicense[]>([]);
  const { contactObject, licensesSyncKey } = useContext(contactContext);
  const contactId = contactObject.Contact?.contactid;

  useEffect(() => {
    if (!contactId) return;
    axios
      .get(`${API_URL}/cmemedicallicense/contact/${contactId}`)
      .then((response: any) => {
        const data: MedicalLicense[] = response.data?.cmemedicallicenses || [];
        setLicenses(data);
        onLicensesLoaded(data);
      })
      .catch(() => {
        setLicenses([]);
        onLicensesLoaded([]);
      });
  // onLicensesLoaded is intentionally omitted — stable at call sites
  // licensesSyncKey increments after each login sync completes, forcing a fresh fetch
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contactId, licensesSyncKey]);

  return (
    <div>
      <div className="licenses-section-header">
        <Typography className="licenses-section-title">
          Licenses
        </Typography>
        <Link
          href={credentialsUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="licenses-section-edit-link"
        >
          <EditOutlinedIcon className="licenses-section-edit-icon" />
        </Link>
      </div>
      {licenses.map((license) => (
        <Typography key={license.Id} variant="body2" className="licenses-section-row">
          State: {license.StateProvince?.Name ?? '—'} | License #: {license.License_Number ?? '—'}
        </Typography>
      ))}
    </div>
  );
};

export default LicensesSection;
